module.exports = __webpack_public_path__ + "img/hint.58f066e3.svg";